import PropTypes from "prop-types";
import { connect } from "react-redux";

import GroupLabel from "./GroupLabel";
import GroupList from "./GroupList";
import GroupListItem from "./GroupListItem";
import StyledItemMarker from "./StyledItemMarker";

const convertGroupPresetToGroup = ({
    floorSpaceID,
    group: { color, displayID, displayName },
}) => ({
    color,
    displayID,
    floorSpaceID,
    groupName: displayName,
});

const defaultGroupDisplayId = 1;

const AddGroup = ({ floorSpaceID, defaultGroups, onAdd, lightGroups }) => {
    const existingDisplayIds = lightGroups.map((group) => group.displayID);

    const groups = defaultGroups
        .filter((group) => group.displayID !== defaultGroupDisplayId)
        .filter((group) => !existingDisplayIds.includes(group.displayID));

    return (
        <GroupList>
            {groups.map((group) => (
                <GroupListItem
                    pointer
                    changeColorOnHover
                    key={group.displayID}
                    onClick={() =>
                        onAdd(
                            convertGroupPresetToGroup({ floorSpaceID, group }),
                        )
                    }
                >
                    <StyledItemMarker $color={group.color} />
                    <GroupLabel>{group.displayName}</GroupLabel>
                </GroupListItem>
            ))}
        </GroupList>
    );
};

AddGroup.propTypes = {
    floorSpaceID: PropTypes.number.isRequired,
    defaultGroups: PropTypes.array.isRequired,
    onAdd: PropTypes.func.isRequired,
    lightGroups: PropTypes.array.isRequired,
};

const mapStateToProps = ({ map }) => ({
    defaultGroups: map.general.defaultLightGroups,
    lightGroups: map.general.lightGroups,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AddGroup);
